<ng-container [formGroup]="versionCellFormGroup">
    <mat-form-field fxFlex.sm="100" fxFlex.xs="100" fxFlex.gt-sm="50" *ngIf="isEditable">
        <mat-label>Template Version</mat-label>
        <mat-select [formControl]="versionFormControl" (selectionChange)="updateVersion($event)">
            <mat-option *ngFor="let version of item.hardwareVersions | keyvalue" [value]="+version.key">
                {{ version.value }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <div fxLayout="row" class="hardware-version-wrapper" *ngIf="!isEditable">
        <div *ngIf="item.hardwareVersion">
            {{ item.hardwareVersion?.toString() | hardwareVersion }}
        </div>
        <mat-icon *ngIf="item.isVersionMismatch" class="icon-20px"
                  matTooltipPosition="right"
                  (mousedown)="showDialog($event)" matTooltip="Version Mismatch">
            warning
        </mat-icon>
    </div>
</ng-container>
